"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var classnames_1 = __importDefault(require("classnames"));

var base_button_css_1 = __importDefault(require("./base-button.css"));

var buttonClasses = function buttonClasses(variant, template, rounded) {
  return (0, classnames_1.default)({
    'border-transparent text-white bg-orange': !variant || variant === 'primary' && template === 1,
    'rounded-md': rounded === true,
    'border-black text-black bg-white': !variant || variant === 'secondary' && template === 1,
    'border-transparent text-white bg-purple': !variant || variant === 'primary' && template === 2,
    'border-purple text-black bg-white': !variant || variant === 'secondary' && template === 2,
    'border-transparent text-white bg-blue': !variant || variant === 'primary' && template === 3,
    'border-blue text-blue bg-white': !variant || variant === 'secondary' && template === 3,
    'border-transparent text-white bg-blue-dark': !variant || variant === 'primary' && template === 4,
    'border-transparent text-blue-dark bg-white': !variant || variant === 'secondary' && template === 4,
    ' items-center px-4 py-2 border shadow-sm text-sm font-medium focus:outline-node focus:ring-2 focus:ring-offset-2': true
  });
};

function Button(_a) {
  var variant = _a.variant,
      template = _a.template,
      rounded = _a.rounded,
      children = _a.children,
      onClick = _a.onClick,
      type = _a.type,
      buttonClassName = _a.buttonClassName,
      props = __rest(_a, ["variant", "template", "rounded", "children", "onClick", "type", "buttonClassName"]);

  return react_1.default.createElement("button", Object.assign({
    /* eslint-disable react/button-has-type */
    type: type,

    /* eslint-enable react/button-has-type */
    className: "".concat(base_button_css_1.default.button, " ").concat(buttonClasses(variant, template, rounded), " ").concat(buttonClassName),
    onClick: onClick
  }, props, {
    rest: true
  }), children);
}

exports.Button = Button;
Button.propTypes = {
  buttonClassName: prop_types_1.default.string,
  variant: prop_types_1.default.string,
  template: prop_types_1.default.number,
  rounded: prop_types_1.default.bool,
  onClick: prop_types_1.default.func,
  type: prop_types_1.default.oneOf(['submit', 'button', 'reset']),
  children: prop_types_1.default.oneOfType([prop_types_1.default.arrayOf(prop_types_1.default.node), prop_types_1.default.node]).isRequired
};
Button.defaultProps = {
  variant: 'primary',
  template: 1,
  rounded: false,
  onClick: function onClick() {},
  type: 'button',
  buttonClassName: ''
};